import { render, staticRenderFns } from "./IngredientForm.vue?vue&type=template&id=274e6f10&scoped=true"
import script from "./IngredientForm.vue?vue&type=script&lang=js"
export * from "./IngredientForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274e6f10",
  null
  
)

export default component.exports